import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Configure axios interceptor GLOBALEMENT pour iOS
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  console.log('[Axios Interceptor] Token from localStorage:', token ? 'EXISTS' : 'NONE');
  
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${token}`;
    console.log('[Axios Interceptor] Added Authorization header');
  }
  
  return config;
}, (error) => {
  console.error('[Axios Interceptor] Error:', error);
  return Promise.reject(error);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
